import { Fields } from '@measured/puck';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, Switch } from '@mui/material';
import WithAccordion from '../../components/customComponents/CustomAccordion';
import GradientPicker from '../../components/GradientPicker';

export interface IGradientProps {
  isGradientChecked: boolean;
  color: string;
}

export interface IGradientFieldsProps {
  gradient: IGradientProps;
}

export const gradientFields: Fields<IGradientFieldsProps> = {
  gradient: {
    type: 'custom',
    label: 'Gradient',
    render: ({ value, onChange }) => {
      return (
        <WithAccordion title="Gradient Color">
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <p className="text-sm font-semibold">Gradient</p>
              <div className="flex gap-0.5 items-center">
                <Tooltip
                  title="Enable to apply a gradient background"
                  placement="top-start">
                  <InfoIcon fontSize="small" className="h-4 w-4" />
                </Tooltip>
                <Switch
                  onChange={e =>
                    onChange({
                      ...value,
                      isGradientChecked: e.target.checked,
                    })
                  }
                  checked={value?.isGradientChecked}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>
            </div>

            {value?.isGradientChecked && (
              <div className="flex flex-col">
                <GradientPicker
                  value={value?.color}
                  onChange={e =>
                    onChange({
                      ...value,
                      color: e,
                    })
                  }
                />
              </div>
            )}
          </div>
        </WithAccordion>
      );
    },
  },
};
